import { ReactNode, useState } from 'react'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'

interface Props {
  title: string
  defaultOpen?: boolean
  children: ReactNode | string
}

export const Accordion = ({ title, defaultOpen = false, children }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="transform transition-all border border-zinc-950/10 dark:border-white/10 rounded-lg p-4">
      <div className="flex flex-row items-center justify-between" onClick={() => setIsOpen(o => !o)}>
        <h3 className="text-base/7 font-semibold text-zinc-950 dark:text-white">{ title }</h3>
        <ChevronLeftIcon className={`transform transition-all h-6 w-6 ${isOpen ? 'rotate-90' : '-rotate-90'}`} />
      </div>
      <div className={`${isOpen ? '' : 'hidden'} pt-4`}>{ children }</div>
    </div>
  )
}
